import React from 'react';
import { isEqual } from 'lodash';
import Dialog from './dialog';
import Alert from '../components/alert';
import SelectTwoColumn, { toOrderedItems, Item } from './select-two-column';
import { MembershipItem } from '../permission-members';
import ErrorHandler from './error-handler';

interface Props {
  show: boolean;
  type: string;
  roles?: ReadonlyArray<Item>;
  objects: ReadonlyArray<MembershipItem>;
  errors?: string[]
  loading?: boolean;
  showTop?: boolean;
  selectedIDs: ReadonlyArray<string>;
  preselectedObjects?: Record<string, string[]>;
  successAlert?: boolean;
  loadingLabel?: string,
  onDone: (edits: string[], touched: boolean) => void;
  onCancel: (ids: string[]) => void;
}

interface State {
  selectedIDs: string[];
  previousSelectedIDs: string[];
}

const TITLES = {
  forms: 'Apps',
  projects: 'Projects',
  layers: 'Layers',
  members: 'Member Permissions',
  groups: 'Groups',
};

export default class PermissionsEditor extends React.Component<Props, State> {
  state: State = {
    selectedIDs: [...this.props.selectedIDs],
    previousSelectedIDs: [...this.props.selectedIDs],
  };

  static getDerivedStateFromProps(props: Props, state: State) {
    if (!isEqual(props.selectedIDs, state.previousSelectedIDs)) {
      return {
        selectedIDs: props.selectedIDs,
        previousSelectedIDs: props.selectedIDs,
      };
    }
    return null;
  }

  getSuccessAlert = () => (
    <Alert severity="success" sx={{ textAlign: 'center' }}>
      Changes saved
    </Alert>
  );

  getErrorsAlert = () => {
    const { errors } = this.props;
    return <ErrorHandler isErrored={!!errors?.length} errorMsg={errors} />;
  };

  handlePositiveClick = () => {
    this.props.onDone(
      this.state.selectedIDs,
      !isEqual(this.props.selectedIDs, this.state.selectedIDs),
    );
  };

  handleNegativeClick = () => {
    if (!isEqual(this.props.selectedIDs, this.state.selectedIDs)) {
      this.setState({
        selectedIDs: [...this.props.selectedIDs],
      }, () => {
        this.props.onCancel([...this.props.selectedIDs]);
      });
    } else {
      this.props.onCancel([...this.props.selectedIDs]);
    }
  };

  handleChange = (selectedValues: string[]) => {
    this.setState({ selectedIDs: selectedValues });
  };

  renderTwoColumnSelect() {
    const { selectedIDs } = this.state;
    const {
      successAlert, type, roles, objects,
      preselectedObjects, errors,
    } = this.props;

    return (
      <>
        {successAlert && this.getSuccessAlert()}
        {!!errors?.length && this.getErrorsAlert()}
        <SelectTwoColumn
          height={370}
          type={type}
          titles={['Available', 'Selected']}
          roles={roles}
          items={toOrderedItems([...objects], 'name', 'id', 'email', 'role_name', 'is_disabled', 'from_group')}
          selectedValues={selectedIDs}
          preselectedObjects={preselectedObjects}
          onChange={this.handleChange}
        />
      </>
    );
  }

  render() {
    const {
      showTop, type, show, loading, loadingLabel,
    } = this.props;
    return (
      <>
        <Dialog
          showTop={showTop}
          title={TITLES[type]}
          show={show}
          width={760}
          maxHeight={560}
          positive="Done"
          processingData={loading}
          loadingLabel={loadingLabel}
          keyboardDisabled
          zIndex={1350}
          onPositiveClick={this.handlePositiveClick}
          onNegativeClick={this.handleNegativeClick}
        >
          {this.renderTwoColumnSelect()}
        </Dialog>
      </>
    );
  }
}
